export { b2CircleDef } from './Collision/Shapes/b2CircleDef';
export { b2CircleShape } from './Collision/Shapes/b2CircleShape';
export { b2ConcaveArcDef } from './Collision/Shapes/b2ConcaveArcDef';
export { b2ConcaveArcShape } from './Collision/Shapes/b2ConcaveArcShape';
export { b2ConvexArcDef } from './Collision/Shapes/b2ConvexArcDef';
export { b2ConvexArcShape } from './Collision/Shapes/b2ConvexArcShape';
export { b2FilterData } from './Collision/Shapes/b2FilterData';
export { b2MassData } from './Collision/Shapes/b2MassData';
export { b2PolygonDef } from './Collision/Shapes/b2PolygonDef';
export { b2PolygonShape } from './Collision/Shapes/b2PolygonShape';
export { b2Shape } from './Collision/Shapes/b2Shape';
export { b2ShapeDef } from './Collision/Shapes/b2ShapeDef';
export { b2StaticEdgeChain } from './Collision/Shapes/b2StaticEdgeChain';
export { b2StaticEdgeChainDef } from './Collision/Shapes/b2StaticEdgeChainDef';
export { b2StaticEdgeShape } from './Collision/Shapes/b2StaticEdgeShape';
export { b2AABB } from './Collision/b2AABB';
export { b2Bound } from './Collision/b2Bound';
export { b2BoundValues } from './Collision/b2BoundValues';
export { b2BroadPhase } from './Collision/b2BroadPhase';
export { b2BufferedPair } from './Collision/b2BufferedPair';
export { b2Collision } from './Collision/b2Collision';
export { b2ContactID } from './Collision/b2ContactID';
export { b2ContactPoint } from './Collision/b2ContactPoint';
export { b2Distance } from './Collision/b2Distance';
export { b2DistanceRegister } from './Collision/b2DistanceRegister';
export { b2Manifold } from './Collision/b2Manifold';
export { b2ManifoldPoint } from './Collision/b2ManifoldPoint';
export { b2OBB } from './Collision/b2OBB';
export { b2Pair } from './Collision/b2Pair';
export { b2PairCallback } from './Collision/b2PairCallback';
export { b2Point } from './Collision/b2Point';
export { b2Proxy } from './Collision/b2Proxy';
export { b2Segment } from './Collision/b2Segment';
export { b2TimeOfImpact } from './Collision/b2TimeOfImpact';
export { ClipVertex } from './Collision/ClipVertex';
export { Features } from './Collision/Features';
export { b2Mat22 } from './Common/Math/b2Mat22';
export { b2Math } from './Common/Math/b2Math';
export { b2Sweep } from './Common/Math/b2Sweep';
export { b2Vec2 } from './Common/Math/b2Vec2';
export { b2XForm } from './Common/Math/b2XForm';
export { b2Color } from './Common/b2Color';
export { b2Settings } from './Common/b2Settings';
export { b2CircleContact } from './Dynamics/Contacts/b2CircleContact';
export { b2ConcaveArcAndCircleContact } from './Dynamics/Contacts/b2ConcaveArcAndCircleContact';
export { b2Contact } from './Dynamics/Contacts/b2Contact';
export { b2ContactConstraint } from './Dynamics/Contacts/b2ContactConstraint';
export { b2ContactConstraintPoint } from './Dynamics/Contacts/b2ContactConstraintPoint';
export { b2ContactEdge } from './Dynamics/Contacts/b2ContactEdge';
export { b2ContactRegister } from './Dynamics/Contacts/b2ContactRegister';
export { b2ContactResult } from './Dynamics/Contacts/b2ContactResult';
export { b2ContactSolver } from './Dynamics/Contacts/b2ContactSolver';
export { b2NullContact } from './Dynamics/Contacts/b2NullContact';
export { b2PolyAndCircleContact } from './Dynamics/Contacts/b2PolyAndCircleContact';
export { b2PolyAndConcaveArcContact } from './Dynamics/Contacts/b2PolyAndConcaveArcContact';
export { b2PolyAndStaticEdgeContact } from './Dynamics/Contacts/b2PolyAndStaticEdgeContact';
export { b2PolygonContact } from './Dynamics/Contacts/b2PolygonContact';
export { b2StaticEdgeAndCircleContact } from './Dynamics/Contacts/b2StaticEdgeAndCircleContact';
export { b2DistanceJoint } from './Dynamics/Joints/b2DistanceJoint';
export { b2DistanceJointDef } from './Dynamics/Joints/b2DistanceJointDef';
export { b2GearJoint } from './Dynamics/Joints/b2GearJoint';
export { b2GearJointDef } from './Dynamics/Joints/b2GearJointDef';
export { b2Jacobian } from './Dynamics/Joints/b2Jacobian';
export { b2Joint } from './Dynamics/Joints/b2Joint';
export { b2JointDef } from './Dynamics/Joints/b2JointDef';
export { b2JointEdge } from './Dynamics/Joints/b2JointEdge';
export { b2MouseJoint } from './Dynamics/Joints/b2MouseJoint';
export { b2MouseJointDef } from './Dynamics/Joints/b2MouseJointDef';
export { b2PrismaticJoint } from './Dynamics/Joints/b2PrismaticJoint';
export { b2PrismaticJointDef } from './Dynamics/Joints/b2PrismaticJointDef';
export { b2PulleyJoint } from './Dynamics/Joints/b2PulleyJoint';
export { b2PulleyJointDef } from './Dynamics/Joints/b2PulleyJointDef';
export { b2RevoluteJoint } from './Dynamics/Joints/b2RevoluteJoint';
export { b2RevoluteJointDef } from './Dynamics/Joints/b2RevoluteJointDef';
export { b2Body } from './Dynamics/b2Body';
export { b2BodyDef } from './Dynamics/b2BodyDef';
export { b2BoundaryListener } from './Dynamics/b2BoundaryListener';
export { b2ContactFilter } from './Dynamics/b2ContactFilter';
export { b2ContactListener } from './Dynamics/b2ContactListener';
export { b2ContactManager } from './Dynamics/b2ContactManager';
export { b2DebugDraw } from './Dynamics/b2DebugDraw';
export { b2DestructionListener } from './Dynamics/b2DestructionListener';
export { b2Island } from './Dynamics/b2Island';
export { b2TimeStep } from './Dynamics/b2TimeStep';
export { b2World } from './Dynamics/b2World';
import { b2PrismaticJoint } from './Dynamics/Joints/b2PrismaticJoint';
import { b2RevoluteJoint } from './Dynamics/Joints/b2RevoluteJoint';
b2PrismaticJoint.axIsType = function (x) {
    return x instanceof b2PrismaticJoint;
};
b2RevoluteJoint.axIsType = function (x) {
    return x instanceof b2RevoluteJoint;
};
